import $ from 'jquery';

export default function notificationSection() {
    const notified = window.localStorage.getItem('notified') !== null;
    const $notification = $('#notification');

    if (!notified && $notification.length > 0) {
        const $body = $('body');
        $body.addClass('is-showing-notification');

        $notification.find('.notification_close').on('click', () => {
            $body.removeClass('is-showing-notification');
            window.localStorage.setItem('notified', '1');
        });
    }
}



// WEBPACK FOOTER //
// ./source/scripts/sections/notification.js